module.exports = __webpack_public_path__ + "img/BlinkArt_Spear1H_Basic.17998956.png";